import { createSlice } from "@reduxjs/toolkit";
import { createApiThunk, updateState } from "./utilityFunction"


// Initial State
const initialState = {
    saveProject: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    fetchProject: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunks

export const fetchProject = createApiThunk("project", "fetch")

export const saveProject = createApiThunk("project", "save")

// Slice
const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        resetProState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchProject = {
                    ...state.fetchProject, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveProject = {
                    ...state.saveProject, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(saveProject.pending, (state) => updateState(state, "pending", "saveProject",))
            .addCase(saveProject.fulfilled, (state, action) => updateState(state, "fulfilled", "saveProject", action.payload.data))
            .addCase(saveProject.rejected, (state, action) => updateState(state, "rejected", "saveProject", action.payload))
            // Fetch projects
            .addCase(fetchProject.pending, (state) => updateState(state, "pending", "fetchProject"))
            .addCase(fetchProject.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchProject", action.payload.data))
            .addCase(fetchProject.rejected, (state, action) =>
                updateState(state, "rejected", "fetchProject", action.payload));
    },
});

export const { resetProState } = projectSlice.actions;
export default projectSlice.reducer;
